export const CURRENT_UI_VIEW_STATE_VERSION = 12;
